<template>
  <BModal id="choice-modal" ref="imageChoiceModal" no-header no-footer :no-close-on-backdrop="true">
    <div class="text-end">
      <BButton @click="hideModal()" aria-label="Close" class="btn-close text-reset"></BButton>
    </div>
    <div class="text-start">
      <p class="h6">どちらの画像に手描きをしますか。</p>
    </div>
    <div class="form-group row" style="margin: 30px 30px">
      <div class="col-sm-6 row h-100">
        <p class="h7 text-center">受注時の手書き画像</p>
        <img :src="getImageA()" class="h-100 ar-3-2">
        <BButton variant="primary" @click="imgChoice(0)" class="image-set-btn">選択</BButton>
      </div>
      <div class="col-sm-2 row"></div>
      <div class="col-sm-6 row h-100">
        <p class="h7 text-center">前回の制作指示画像</p>
        <img :src="getImageB()" class="h-100 ar-3-2">
        <BButton variant="primary" @click="imgChoice(1)" class="image-set-btn">選択</BButton>
      </div>
    </div>
  </BModal>
</template>
<script>
import { BModal, BButton } from 'bootstrap-vue-next'
export default {
  name: 'ImageChoiceModal',
  components: {
    BModal,
    BButton
  },
  data () {
    return {
      imageA: '',
      imageB: ''
    }
  },
  methods: {
    showModal (imageA, imageB) {
      this.imageA = imageA
      this.imageB = imageB
      this.$refs.imageChoiceModal.show()
    },
    hideModal () {
      this.$refs.imageChoiceModal.hide()
    },
    getImageA () {
      return this.imageA
    },
    getImageB () {
      return this.imageB
    },
    imgChoice (choiceNum) {
      if (choiceNum === 0) {
        this.$emit('ImageA')
      } else {
        this.$emit('ImageB')
      }
      this.$refs.imageChoiceModal.hide()
    }
  }
}
</script>
<style>
.image-set-btn {
  margin: 5px auto;
}
.h7{
  font-size: 0.8rem;
}
.text-center {
  margin-left: auto;
  margin-right: auto;
}
</style>
